import styled from "@emotion/styled";
import {
  generateOTPInputFieldWrapperStyles,
  generateOTPFieldBoxStylesProps,
  generateTextStyles,
  getCircleIconStyles,
} from "../../utils";
import { BORDER_RADIUS } from "../../utils/constants";
import {
  CircleIconProps,
  generateOTPFieldStylesProps,
} from "./OTPInputField.types";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const OTPInputFieldContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
`;

export const OTPInputFieldWrapper = styled.div<generateOTPFieldStylesProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  padding: 5px 14px 0px 14px;
  border-radius: ${BORDER_RADIUS};
  cursor: pointer;
  ${(props) => generateOTPInputFieldWrapperStyles(props)}
`;

export const OTPInputFieldsContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: space-between;
  width: 100%;
  position: relative;
  bottom: -2px;
`;

export const OTPInputFieldBox = styled.input<generateOTPFieldStylesProps>`
  width: 100%;
  height: 30px;
  border: none;
  appearance: none;
  cursor: pointer;
  padding: 0 0 0 6%;
  align-items: center;
  text-align: center;
  outline: none;
  background-color: transparent;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ${(props) => generateOTPFieldBoxStylesProps(props)}
  ${generateTextStyles({
    type: "body",
    fontWeight: "medium",
    variant: 4,
  })}
`;
export const CircleIcon = styled.i<CircleIconProps>`
  ${(props) => getCircleIconStyles(props)}
  margin: 4px 14px 0 4px;
  font-size: 12px;
`;

export const SupportingText = styled.div<CircleIconProps>`
  display: flex;
  margin-top: 10px;
  align-items: flex-start;
  justify-content: flex-start;

  ${(props) => getCircleIconStyles(props)}
`;
